<template>
  <div class="contact">
    <div class="main-banner" :style="'background-image: url('+bannerList+');'">
    	<div class="banner-title">
    		<h2>联系我们</h2>
    		<h3>Contact us</h3>
    	</div>
    </div>
    <div class="container">
			<div class="text">
				<p>{{$t('contact.text')}}</p>
			</div>
			<div class="conNav">
				<div>
					<span>{{$t('contact.list01.title')}}</span>
					<p>{{$t('contact.list01.text1')}}</p>
					<p>{{$t('contact.list01.text2')}}</p>
					<p>{{$t('contact.list01.text3')}}</p>
					<p>{{$t('contact.list01.text4')}}</p>
					<p>{{$t('contact.list01.text5')}}</p>
				</div>
        <div v-show="language=='cn'">
        	<span>{{$t('contact.list02.title')}}</span>
        	<p>{{$t('contact.list02.text1')}}</p>
        	<p>{{$t('contact.list02.text2')}}</p>
        	<p>{{$t('contact.list02.text3')}}</p>
        	<!-- <p>{{$t('contact.list02.text4')}}</p> -->
        </div>
			</div>
			<div class="map">
				<baidu-map class="bm-view" :center="infoWindow.posit" :zoom="15" :scroll-wheel-zoom="true">
					<bm-marker :position="infoWindow.posit" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" />
					<bm-info-window :position="infoWindow.posit" :title="$t('corp.name')" :show="infoWindow.show">
						<p v-text="$t('corp.address')"></p>
					</bm-info-window>
				</baidu-map>
			</div>
      <div class="messages">
        <div class="messages-title">
          <h2>在线留言</h2>
          <h3>Online Message</h3>
          <p>{{$t('contact.online.text')}}</p>
        </div>
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item :label="$t('contact.online.name')" prop="name" style="display: inline-block;">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contact.online.phone')" prop="phone" style="display: inline-block;">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contact.online.Email')" prop="email" style="display: inline-block;">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item class="textarea" :label="$t('contact.online.message')" prop="desc" style="margin: 0 auto;width: 858px;margin-bottom: 22px;">
            <el-input type="textarea" v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item class="submit">
            <el-button type="primary" @click="onSubmit('form')">{{$t('contact.online.submit')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
		</div>
  </div>
</template>

<script>
  export default {
  	name: 'contact',
  	data() {
  		return {
			language: 'cn',
				bannerList: [],
				infoWindow: {
					show: true,
					contents: '广东省佛山市南海区狮山科技工业园C区兴业路14号',
					posit:{lng: 113.008553, lat: 23.105974},
				},
        form: {
          name: '',
          phone: '',
          email: '',
          desc: ''
        },
				rules: {
					name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
					phone: [
						{ required: true, message: '请输入电话', trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入邮箱', trigger: 'blur' }
					],
					desc: [
						{ required: true, message: '请输入内容', trigger: 'blur' }
					],
				}
  		};
  	},
		mounted() {
			this.bannerApi();
			sessionStorage.getItem('locale')==''?this.language = sessionStorage.getItem('locale'):'';
			console.log(this.language)
		},
		methods: {
      onSubmit(e) {
				var that = this;
				var data = that.form;
				this.$refs[e].validate(function(valid){
					if(valid){
						console.log(that.form);
						that.axios({
							method: 'post',
							url:'http://ad.dinovor.com/message/websiteMessages',
							contentType:'application/json;charset=utf-8',
							dataType:'json',
							data:{
								"content": data.desc,
								"email": data.email,
								"mobile": data.phone,
								"name": data.name
							}
						}).then(function(res) {
							if(res.data.rtnCode == 200){
								alert('提交成功')
							}else{
								alert(res.data.msg);
							}
						})
					}else{
						return false;
					}
				});
      },
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 5
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}
					}
				);
			}
		},
    metaInfo: {
      title: '佛山鼎吉-联系我们', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.contact{
	background: #FFFFFF;
	padding-bottom: 50px;
}
.contact .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.contact .text{
	width: 60%;
	margin: 0 auto;
	margin-top: 50px;
}
.contact .text p{
	font-size: 12px;
	line-height: 24px;
	color: #999;
	text-align: center;
}
.contact .conNav{
	display: flex;
	justify-content: center;
	margin-top: 40px;
}
.contact .conNav>div{
	padding: 0 10px;
}
.contact .conNav>div span{
	display: block;
	margin-bottom: 30px;
	font-weight: bold;
	color: #6b6b6b;
}
.contact .conNav>div p{
	font-size: 12px;
	margin-bottom: 10px;
	color: #999;
}
.contact .map{
	margin-top: 50px;
}
.bm-view{
	height: 400px;
}
.anchorBL{
	display: none;
}
.messages{
  width: 900px;
  margin: 0 auto;
  margin-top: 60px;
  padding: 40px;
  box-shadow: 0 0 30px 0 #e0e0e0;
}
.messages h2{
  margin-bottom: 10px;
}
.messages h3{
  margin-bottom: 20px;
}
.messages p{
  font-size: 12px;
  color: #a999;
	text-align: center;
}
.messages .messages-title{
  margin-bottom: 40px;
}
.messages .el-form-item__label{
  color: #aeaeae;
}
.messages .el-textarea__inner{
	min-height: 100px !important;
}
.messages .el-button--primary{
  background: #333;
  border-color: #333;
}
@media (max-width: 992px){
	.contact .text{
		width: 100%;
	}
	.messages{
		width: 100%;
		padding: 40px 0;
		display: none;
	}
	.messages .el-form{
		padding: 0 20px;
		display: none;
	}
	.messages .el-form .el-form-item{
		width: 100%;
	}
	.messages .el-form-item__label{
		width: 40px !important;
	}
	.messages .textarea{
		display: inline-block;
		width: 100% !important;
	}
	.messages .submit .el-form-item__content{
		margin-left: 0 !important;
	}
  .contact .conNav{
    flex-wrap: wrap;
  }
  .contact .conNav>div{
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  .contact .conNav>div span{
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue